<template>
    <div class="stars">
        <span :class="['star-item',{on:index<score}]" v-for="(item,index) in 5" :key="index" @click="change(index)">
            <svg class="icon" style="width: 1em; height: 1em;vertical-align: middle;fill: currentColor;overflow: hidden;" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1873"><path d="M511.082606 89.707115 640.347668 381.582695 957.756785 415.585113 720.110293 628.727515 785.8526 941.099918 509.716492 780.939195 232.943888 940.007027 299.926442 627.883287 63.132364 413.8107 380.657114 381.064902 511.082606 89.707115Z" p-id="1874"></path></svg>
        </span>
        <span class="tip" v-if="showTips">{{tips[score-1]}}</span>
    </div>
</template>
<script>
export default{
    props:{
        score:{
            type:[Number,String],
            default:5,
        },
        showTips:{
            type:Boolean,
            default:false,
        },
        disabled:{
            type:[Boolean,Number,String],
            default:false,
        }
    },
    data() {
        return {
            tips:['非常差','差','一般','好','非常好']
        }
    },
    methods: {
        change(index){
            if(this.disabled)return;
            this.$emit('change',index+1);
        }
    },
}
</script>
<style lang="scss">
.stars{
    white-space: nowrap;
    .star-item{
        float: left;
        font-size: 24px;
        color: #ebebeb;
        overflow: hidden;
        cursor: pointer;
        margin-right: 1px;
        &.on{
            color: #ff3838;
        }
        .icon{
            float: left;
        }
    }
    .tip{
        color: #999;
        font-size: 12px;
        line-height: 24px;
        margin-left: 10px;
    }
}
</style>